
const RevisionUtils = {
  getLocalStorageRevision: function () {
    return '1.0.10.1'
  }
}

export default RevisionUtils
